interface EmptyStateProps {
  icon: string;
  title: string;
  subtitle?: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
}

export function EmptyState({
  icon,
  title,
  subtitle,
  buttonLabel,
  onButtonClick,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-8 px-4 text-center">
      <span className="text-4xl">{icon}</span>
      <p className="font-semibold text-sm text-gray-500 dark:text-gray-400">
        {title}
      </p>
      {subtitle && (
        <p className="text-xs text-gray-400 dark:text-gray-500 max-w-xs">
          {subtitle}
        </p>
      )}
      {buttonLabel && onButtonClick && (
        <button
          onClick={onButtonClick}
          className="mt-2 px-4 py-2 rounded-xl text-sm font-medium border border-gray-200 dark:border-white/10 hover:bg-gray-50 dark:hover:bg-white/5 transition-colors"
        >
          {buttonLabel}
        </button>
      )}
    </div>
  );
}
